export default "__VITE_ASSET__DnrVekGU__"